const invalidProtocolRegex = /^(%20|\s)*(javascript|data)/im;
const ctrlCharactersRegex = /[^\x20-\x7EÀ-ž]/gim;
const urlSchemeRegex = /^([^:]+):/gm;
const relativeFirstCharacters = [".", "/"];
// ------------------------------------------------------------------------------------------------
export function sanitizeUrl(url?: string): string {
    if (!url) {
        return "about:blank";
    }
    const sanitizedUrl = url.replace(ctrlCharactersRegex, "").trim();

    // isRelativeUrlWithoutProtocol
    if (relativeFirstCharacters.indexOf(sanitizedUrl[0]) > -1) {
        return sanitizedUrl;
    }

    const urlSchemeParseResults = sanitizedUrl.match(urlSchemeRegex);
    if (!urlSchemeParseResults) {
        return sanitizedUrl;
    }

    const urlScheme = urlSchemeParseResults[0];
    if (invalidProtocolRegex.test(urlScheme)) {
        return "about:blank";
    }

    return sanitizedUrl;
}
// ------------------------------------------------------------------------------------------------